/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Delivery_Whatsapp_Link_Dialog_TitleInputs */

const he_account_delivery_whatsapp_link_dialog_title = /** @type {(inputs: Account_Delivery_Whatsapp_Link_Dialog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`חיבור ווטסאפ`)
};

const en_account_delivery_whatsapp_link_dialog_title = /** @type {(inputs: Account_Delivery_Whatsapp_Link_Dialog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link WhatsApp`)
};

/**
* | output |
* | --- |
* | "Link WhatsApp" |
*
* @param {Account_Delivery_Whatsapp_Link_Dialog_TitleInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const account_delivery_whatsapp_link_dialog_title = /** @type {((inputs?: Account_Delivery_Whatsapp_Link_Dialog_TitleInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Delivery_Whatsapp_Link_Dialog_TitleInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_account_delivery_whatsapp_link_dialog_title(inputs)
	return en_account_delivery_whatsapp_link_dialog_title(inputs)
});